import React from 'react';

import { Nullable } from '@clearverify/types';
import { parseNullableValue } from '@clearverify/utils';

import { PermissiblePurposesItemFragment, usePermissiblePurposesListQuery } from 'src/api';
import { SelectFieldOption } from 'src/types/components';
import { buildPermissiblePurposesFilter } from 'src/utils/permissiblePurposes';

type PermissiblePurposesOption = {
  value: string;
  label: string;
};

interface PermissiblePurposesHookResult {
  permissiblePurposesOptions: PermissiblePurposesOption[];
  permissiblePurposes: PermissiblePurposesItemFragment[];
  isPermissiblePurposesLoading: boolean;
}

export const usePermissiblePurposesOptions = (
  verifierId: Nullable<string>,
): PermissiblePurposesHookResult => {
  const { data, loading: isPermissiblePurposesLoading } = usePermissiblePurposesListQuery({
    variables: {
      filter: buildPermissiblePurposesFilter(verifierId ?? ''),
    },
    skip: !verifierId,
  });

  const permissiblePurposes = React.useMemo(() => {
    return data?.permissiblePurposeList ?? [];
  }, [data]);

  const permissiblePurposesOptions = React.useMemo(
    (): SelectFieldOption[] =>
      permissiblePurposes.map(item => {
        return {
          value: item.id,
          label: parseNullableValue(item.permissiblePurposeReference.label),
        };
      }),
    [permissiblePurposes],
  );

  return { permissiblePurposesOptions, permissiblePurposes, isPermissiblePurposesLoading };
};
